import React from 'react';
import { getVehicleTypeByChasis, getVehicleIconClass } from '../../utils/vehicleIconUtils';

interface VehicleIconProps {
    chassis?: string;
    className?: string;
    size?: number;
}

const VehicleIcon: React.FC<VehicleIconProps> = ({ 
    chassis, 
    className = '',
    size = 64 
}) => {
    const vehicleType = getVehicleTypeByChasis(chassis);
    const iconClass = getVehicleIconClass(vehicleType);
    const fontSize = size * 0.75; // Proporção do ícone em relação ao container

    return (
        <span 
            className={`rioglyph ${iconClass} bg-black text-white rounded-full flex items-center justify-center ${className}`}
            aria-label="Ícone de veículo"
            style={{ 
                fontSize: `${fontSize}px`, 
                minWidth: `${size}px`, 
                minHeight: `${size}px`, 
                width: `${size}px`, 
                height: `${size}px` 
            }}
        />
    );
};

export default VehicleIcon;

